export default __webpack_public_path__ + "static/media/08AW1MAR66.19935ced.jpg";